import script from "./Groups.vue?vue&type=script&lang=ts&setup=true"
export * from "./Groups.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__